import { createAction, createSlice } from "@reduxjs/toolkit";
import { Organization } from "../../@types/organization";
import { Message } from "../../@types/message";
import { UserRole } from "../../@types/userRole";
import { findOrganization } from "./actions/findOrganization";
import { findMessages } from "./actions/findMessages";
import { findUserRoles } from "./actions/findUserRoles";
interface OrganizationShowState {
  organization: Organization;
  userRoles?: UserRole[];
  messages?: Message[];
  segmentSelected: string;
}

const initialState = {
  organization: {},
  userRoles: [],
  messages: [],
  segmentSelected: "",
} as OrganizationShowState;

export const setSegmentSelected = createAction<string>("SET_SEGMENT_SELECTED");

const organizationShowSlice = createSlice({
  name: "organizationShow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(findOrganization.fulfilled, (state, { payload }) => {
        state.organization = payload;
        state.segmentSelected = "info";
      })
      .addCase(findUserRoles.fulfilled, (state, { payload }) => {
        state.userRoles = payload;
      })
      .addCase(findMessages.fulfilled, (state, { payload }) => {
        state.messages = payload;
      })
      .addCase(setSegmentSelected, (state, { payload }) => {
        state.segmentSelected = payload;
      });
  },
});

export default organizationShowSlice.reducer;
